import { Injectable } from '@angular/core';
import { Observable, Subject, fromEvent, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppService } from './app.service';
import { BaseService } from './base.service';

@Injectable()
export class ApiService {

  //-- VARIABLES -------------------------------------------------------|

  private _meta: any = {};

  private securitiSetup: boolean = false;

  private enteredLast4: string = '';

  private _appData = new Subject<any>();
  $appData = this._appData.asObservable();

  private _lazyLoading = new Subject<boolean>();
  $lazyLoading = this._lazyLoading.asObservable();

  private assetsBaseUrl: string = '';

  //-- CONSTRUCTOR -----------------------------------------------------|

  constructor(private http: BaseService, private appService: AppService) {
    this.assetsBaseUrl = this.appService.ENV.ASSETS_BASE_URL;
  }

  //-- UTILITY METHODS -------------------------------------------------|

  getData() { return this._meta || {}; }

  private API_BASE() {
    return `${this.appService.ENV.API_BASE_URL}/${this.appService.ENV.APP_ID}/promotion/${this.appService.ENV.PROMO_CODE}`;
  }

  private sendIframeReadyEvent(){
    if(this.securitiSetup) return;
    setTimeout(() => { window.parent.postMessage({
      type: 'IFRAME_READY'
    }, '*'); this.securitiSetup = true;}, 0);
  }

  private resetMeta() {
    this._meta = {};
    this.enteredLast4 = ""
  }

  private callback() {
    this._appData.next(this._meta);
    this._lazyLoading.next(false);
    this.appService.setLoadingStatus(false);
    this.sendIframeReadyEvent();
  }

  //-- GET OFFER -------------------------------------------------------|

  public offer() {

    this.resetMeta();

    const url: string = `${this.API_BASE()}`;

    return this.http.get(url)
      .subscribe(
        (response) => {
          this.promoCallback(response);
          this.callback();
        },
        (error) => {
          this.redirectHandler(error);
          this.callback();
        });
  }

  promoCallback(response: any) {

    if (response != undefined) {

      if (response.Data != undefined) {
        this._meta.SUCCESS = true;
      }

      if (response.ErrorMsg != undefined) {
        this.redirectHandler(response.ErrorMsg);
      }
    }
  }

  //-- GET MEMBER PROMOTION --------------------------------------------|

  public memberPromotion(mpId: string, cardNumber: string) {

    let url: string = `${this.API_BASE()}/submit/${mpId}`;
    this.enteredLast4 = cardNumber;
    let param = {
      cardNumber: cardNumber,
      promotionId: this.appService.ENV.PROMO_CODE
    };

    this.resetRegisterMetaData();

    return this.http.patch(url, param)
      .subscribe(
        (response) => {
          this.memberPromoCallback(response, mpId);
          this.callback();
        },
        (error) => {
          this.redirectHandler(error);
          this.callback();
        });
  }

  memberPromoCallback(response: any, mpId: string) {
    this._meta.SUCCESS_OFFER_TYPES = true;
    this._meta.MP_ID = mpId.toUpperCase();
    this._meta.MASK_MP_ID = response.MpId;
    this._meta.FIRST_NAME = response.DisplayName;
    this._meta.CARD_IMG = this.getPngFileName(response.Rpc);
  }

  //-- GET MEMBER PROMOTION --------------------------------------------|

  public register(rewardsNumber: string) {

    const url: string = `${this.API_BASE()}/register/${this._meta.MP_ID}`;

    const param = {
      promotionId: this.appService.ENV.PROMO_CODE,
      partnerAlias: rewardsNumber,
      cardNumber: this.enteredLast4
    };

    this.resetRegisterMetaData();

    return this.http.patch(url, param)
      .subscribe(
        (response) => {
          this.appService.redirectTo(this.appService._OFFER);
          this.callback();
        },
        (error) => {
          this.redirectHandler(error);
          this.callback();
        });
  }

  private resetRegisterMetaData() {
    this._meta.ACTION = '';
    this._meta.OFFER_TYPES = undefined;
    this._meta.SUCCESS_OFFER_TYPES = undefined;
  }

  getPngFileName(rpc: string) {
    let cardImgName = this.assetsBaseUrl + "cards/";
    switch(rpc){
      case '437':
        cardImgName += 'Club_Consumer_Infinite';
        break;
      case '479':
        cardImgName += 'Club_Business_Visa';
        break;
      case '341':
        cardImgName += 'United_Presidential_Plus_Card';
        break;
      case '415':
        cardImgName += 'Presidential_Plus_Business_MasterCard';
        break;
      default:
        cardImgName += 'MileagePlus_Generic_MasterCard';
        break;
    }
    return cardImgName + '.png';   
    
  }

  //-- UTILITY METHODS -------------------------------------------------|

  public isAuthenticated(): Observable<boolean> {
    if (sessionStorage.getItem('lyt-auth-token')) {
      return of(true);
    }
    return fromEvent(document, 'micrositeAuth').pipe(map(e => true));
  }

  redirectHandler(error: string) {

    switch (error) {
      case 'PROMOTION:ENDED':
      case 'PROMOTION:NOT_FOUND':
      case 'PROMOTION:NOT_FOUND_1':
      case 'PROMOTION:NOT_FOUND_2':
        this.appService.redirectTo(this.appService._ENDED);
        break;
      case 'UNAUTHORIZED':
      case 'MEMBER:CARD_INVALID':
      case 'MEMBER:PARTNER_INVALID':
        this.appService.redirectTo(this.appService._INCORRECT);
        break;
      case 'SERVICE:ERROR':
      case 'APPLICATION:ERROR':
      default:
        if (error.indexOf('IHG') > -1) {
          this.appService.redirectTo(error.indexOf('already') > -1 ? this.appService._ALREADY : this.appService._INELIGIBLE);
        }
        else {
          this.appService.redirectTo(this.appService._ERROR);
        }
        break;
    }
  }

  monthNames: Array<string> = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  private dateFormat(res: string) {

    if (res != '') {

      const year = res.substring(0, 4);
      const month = res.substring(5, 7);
      const day = res.substring(8, 10)

      const monthName = this.monthNames[(Number(month) - 1)]

      return `${monthName} ${day}, ${year}`;
    }

    return '';
  }

  //--------------------------------------------------------------------|

}